import { render, staticRenderFns } from "./OrderReceiptEmailModal.vue?vue&type=template&id=5b36bd2a&"
import script from "./OrderReceiptEmailModal.vue?vue&type=script&lang=js&"
export * from "./OrderReceiptEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports